/* zk-dates.js — تنظيف التواريخ */
(function(){
'use strict';
var NEW='مساء ٢٧ أغسطس';
var LBL='ستظهر تمارين الجلسة';
var ZW=String.fromCharCode(8203);
var DEAD=/(^|[^0-9٠-٩])(?:مساء\s*)?(?:15|18|25|١٥|١٨|٢٥)\s*أغسطس(?:\s*(?:2026|٢٠٢٦))?/g;
var ISDEAD=/(?:^|[^0-9٠-٩])(?:15|18|25|١٥|١٨|٢٥)\s*أغسطس/;
var KILL=/بداية\s+الجلسة/;
var LAUNCH=/إطلاق\s+النوايا/;
var ANT=/انطلاقة?/g;

function fixDate(s){return String(s).replace(DEAD,'$1'+NEW)}

function shift(obj,pre,a,b){
  if(!obj)return;
  var rows=[],i,k1,k2,keys=[];
  for(i=1;i<=12;i++){
    k1=pre+i+a;k2=pre+i+b;
    if(!(k1 in obj)&&!(k2 in obj))continue;
    keys.push([k1,k2]);
    var nm=String(obj[k1]==null?'':obj[k1]);
    var dv=String(obj[k2]==null?'':obj[k2]);
    if(KILL.test(nm))continue;
    if(LAUNCH.test(nm))nm=LBL;
    if(ISDEAD.test(dv))dv=NEW;
    if(nm||dv)rows.push([nm,dv]);
  }
  if(!rows.length)return;
  for(i=0;i<keys.length;i++){
    var r=rows[i];
    obj[keys[i][0]]=r?r[0]:ZW;
    obj[keys[i][1]]=r?r[1]:ZW;
  }
}

function run(){
  var ZK=window.ZK||{};
  shift(ZK.bundle2,'s','n','d');
  shift(ZK.bundle,'s','n','d');
  shift(ZK.luck,'d','l','v');
  shift(ZK.luck2,'d','l','v');
  Object.keys(ZK).forEach(function(g){
    var o=ZK[g];if(!o||typeof o!=='object')return;
    Object.keys(o).forEach(function(k){
      if(typeof o[k]!=='string')return;
      if(KILL.test(o[k]))o[k]=o[k].replace(/\s*—?\s*بداية\s+الجلسة/g,'').trim();
      if(ISDEAD.test(o[k]))o[k]=fixDate(o[k]);
      if(ANT.test(o[k]))o[k]=o[k].replace(ANT,'').replace(/\s{2,}/g,' ').trim();
    });
  });
  var M=window.ZKM;
  if(M){
    if(M.date_label&&(KILL.test(M.date_label)||LAUNCH.test(M.date_label)))M.date_label=LBL;
    if(M.date_value&&ISDEAD.test(M.date_value))M.date_value=NEW;
  }
}
run();

function sweep(){
  var root=document.getElementById('zk');if(!root)return;
  var w=document.createTreeWalker(root,NodeFilter.SHOW_TEXT,null),n;
  while((n=w.nextNode())){
    var t=n.nodeValue;if(!t||!t.trim())continue;
    var o=t;
    t=t.replace(/\s*—?\s*بداية\s+الجلسة/g,'');
    t=fixDate(t);
    t=t.replace(ANT,'');
    if(t!==o)n.nodeValue=t;
  }
  var seen={},rows=[].slice.call(root.querySelectorAll('.dt'));
  rows.forEach(function(el){
    var raw=el.innerText||'';
    if(raw.indexOf(ZW)!==-1){el.remove();return}
    var k=raw.replace(/\s+/g,' ').trim();
    if(!k)return;
    if(seen[k]){el.remove();return}
    seen[k]=1;
  });
}
var tries=0;
(function go(){sweep();if(++tries<25)setTimeout(go,300)})();
})();
